import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client';
import { isEmpty } from '@newfront-insurance/core';
import { useMemo } from 'react';
import { GET_SLASH_COMMANDS, type SlashCommand } from '../queries/chats';
interface UseSlashCommandsOptions {
  accountUuid?: string;
  userUuid?: string;
}
interface SlashCommandGroup {
  category: string;
  commands: SlashCommand[];
}
export function useSlashCommands(t0) {
  const $ = _c(20);
  const {
    accountUuid,
    userUuid
  } = t0;
  const t1 = userUuid ?? "";
  let t2;
  if ($[0] !== accountUuid || $[1] !== t1) {
    t2 = {
      accountUuid,
      userUuid: t1
    };
    $[0] = accountUuid;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== userUuid) {
    t3 = isEmpty(userUuid);
    $[3] = userUuid;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = {
      variables: t2,
      skip: t3,
      fetchPolicy: "cache-and-network"
    };
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const {
    data,
    loading,
    error
  } = useQuery(GET_SLASH_COMMANDS, t4);
  data?.slashCommands;
  let t5;
  let t6;
  if ($[8] !== data?.slashCommands) {
    t6 = data?.slashCommands ?? [];
    $[8] = data?.slashCommands;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  t5 = t6;
  const commands = t5;
  let t7;
  let t8;
  if ($[10] !== commands) {
    const groups = {};
    commands.forEach(command => {
      const {
        category
      } = command;
      if (!groups[category]) {
        groups[category] = [];
      }
      groups[category].push(command);
    });
    t8 = Object.entries(groups).map(_temp);
    $[10] = commands;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  t7 = t8;
  const groupedCommands = t7;
  let t9;
  let t10;
  if ($[12] !== commands) {
    t10 = query => {
      if (isEmpty(query)) {
        return commands;
      }
      const normalizedQuery = query.toLowerCase().replace(/^\//, "");
      return commands.filter(command_0 => command_0.handle.toLowerCase().includes(normalizedQuery) || command_0.description.toLowerCase().includes(normalizedQuery));
    };
    $[12] = commands;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  t9 = t10;
  const filterCommands = t9;
  let t11;
  if ($[14] !== commands || $[15] !== error || $[16] !== filterCommands || $[17] !== groupedCommands || $[18] !== loading) {
    t11 = {
      commands,
      groupedCommands,
      filterCommands,
      isLoading: loading,
      error
    };
    $[14] = commands;
    $[15] = error;
    $[16] = filterCommands;
    $[17] = groupedCommands;
    $[18] = loading;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  return t11;
}
function _temp(t0) {
  const [category_0, categoryCommands] = t0;
  return {
    category: category_0,
    commands: categoryCommands
  };
}